(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bfa-script"] && !Shopify.designMode) return;
  try {
    (() => {
  /* October 14, 2026. CLARITY CONVERSION EVENTS.

     Clarity only records page views and clicks unless the page tells it
     what happened. These 4 calls name the L'Atelier steps: a scene viewed
     (a tag, so recordings can be filtered by scene), a photo added, a
     canvas added to the cart, and the checkout button pressed with a canvas
     in the cart. The Microsoft Clarity app embed defines window.clarity,
     with a queue, before this file runs. Every call is guarded and wrapped,
     so a page without Clarity, or with Clarity blocked, behaves exactly as
     before and never throws. */
  const bfaClarity = (...args) => {
    try { if (typeof window.clarity === 'function') window.clarity(...args); } catch (error) {}
  };
  let bfaCartHasCanvas = null;
  const bfaCheckCart = () => {
    try {
      fetch('/cart.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}})
        .then(response => response.ok ? response.json() : null)
        .then(cart => { if (cart) bfaCartHasCanvas = (cart.items || []).some(item => item && item.product_type === 'Canvas'); })
        .catch(() => {});
    } catch (error) {}
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-compare]:not([data-ready])').forEach(el => {
      el.dataset.ready = 'true';
      el.querySelector('input')?.addEventListener('input', event => el.style.setProperty('--reveal', `${event.target.value}%`));
      /* October 12, 2026. On iPhone a range input only moves when its thumb
         is touched, so a finger anywhere on the picture now drags the
         reveal. Touch and pen only: a mouse keeps the native range. The
         stylesheet sets touch-action: pan-y, so a vertical swipe still
         scrolls the page and cancels the drag. */
      const range = el.querySelector('input');
      if (range && window.PointerEvent) {
        let active = null;
        const follow = event => {
          const box = el.getBoundingClientRect();
          if (!box.width) return;
          const value = Math.max(0, Math.min(100, Math.round((event.clientX - box.left) / box.width * 100)));
          range.value = String(value);
          el.style.setProperty('--reveal', `${value}%`);
        };
        el.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse') return;
          active = event.pointerId;
          follow(event);
        });
        el.addEventListener('pointermove', event => { if (event.pointerId === active) follow(event); });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(type => el.addEventListener(type, event => {
          if (event.pointerId === active) active = null;
        }));
      }
    });
    scope.querySelectorAll('[data-size-guide]:not([data-ready])').forEach(el => {
      el.dataset.ready = 'true';
      const tabs = [...el.querySelectorAll('[data-tab]')];
      const select = tab => {
        tabs.forEach(item => {item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1;});
        el.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = tabs[(i+1)%tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(i-1+tabs.length)%tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length-1];
          if (next) {event.preventDefault(); select(next); next.focus();}
        });
      });
    });

    /* The size guide opens as a dialog from the buy box. The jump is
       prevented only when a dialog is actually there, so setting the size
       section back to a page section needs no other change: the same link
       falls through and scrolls to #size-guide exactly as it used to.

       🔴 THE PHOTO GUIDE BUTTON IS EXCLUDED BY NAME. It was given
       .bfa-size-link in sections/bfa-product.liquid so it would look like the
       size guide link beside step 03, and that alone made this binder match
       it. The section binds its own opener on [data-photo-guide-open], so 1
       click ran both: the photo guide opened and the size and hanging guide
       opened on top of it. Do not take the exclusion back out. */
    scope.querySelectorAll('.bfa-size-link:not([data-ready]):not([data-photo-guide-open])').forEach(link => { /* never the photo guide button, the section opens that dialog itself */
      link.dataset.ready = 'true';
      link.addEventListener('click', event => {
        const dialog = document.getElementById('bfa-size-dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        dialog.showModal();
      });
    });

    scope.querySelectorAll('[data-art-open]:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      button.addEventListener('click', () => document.getElementById(button.dataset.artOpen)?.showModal());
    });
    scope.querySelectorAll('.bfa-art-dialog:not([data-ready])').forEach(dialog => {
      dialog.dataset.ready = 'true';
      dialog.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {if (event.target === dialog) {const b = dialog.getBoundingClientRect(); if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();}});
    });

    /* --------------------------------------------------------------------
       The buy box.

       Rewritten September 15, 2026 for 2 reasons.

       1. THE VARIANT GRID IS NOT FULL. Panoramic framed is blueprint 944 and
          panoramic frameless is 1159, and the 2 carry different size ladders,
          so 10 of the 25 size and finish combinations on every panoramic are
          not products. The old code filtered sizes by finish but never the
          other way, and never said anything when a combination did not exist.
          It now proves every choice against the real variant list in both
          directions and states plainly when a combination is not made.

       2. IT FAILED OPEN IN THE WRONG DIRECTION. The native select was hidden
          and the enhanced picker revealed at the END of setup. Anything that
          threw before that line left the shopper with a raw list of all 15
          variants and a form that posted an id the cart could not resolve,
          which is the "cannot find variant" Nico hit. Setup now runs inside
          try and catch, and the native select, which is always correct
          because Liquid only ever writes real variants into it, stays in
          place if anything goes wrong.

       Option positions come from the section as data-size-index and
       data-frame-index rather than being assumed to be option1 and option2.

       September 19, 2026. The dog's name and weight became their own step
       above the photographs, so there is 1 more number to keep in step. It
       is in the section at source (the gift message that was wired here
       was removed October 1, 2026); the 3 patch snippets that briefly did this after render are gone.
    -------------------------------------------------------------------- */
    scope.querySelectorAll('[data-bfa-product]:not([data-ready])').forEach(el => {
      el.dataset.ready = 'true';
      {
        const sceneHandle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
        if (sceneHandle) bfaClarity('set', 'atelier_scene', decodeURIComponent(sceneHandle));
      }
      const q = sel => el.querySelector(sel);
      const qa = sel => [...el.querySelectorAll(sel)];
      let ready = false;

      try {
        const variants = JSON.parse(q('[data-variant-data]').textContent);
        const strings = JSON.parse(q('[data-product-strings]').textContent);
        const form = q('form');
        const submit = q('[data-submit]');
        const submitText = q('[data-submit-text]');
        const result = q('[data-cart-result]');
        const sizes = qa('[name="bfa-size"]');
        const finishes = qa('[name="bfa-finish"]');
        const canvasTypes = qa('[name="bfa-canvas-type"]');
        const colorOptions = q('[data-frame-color-options]');
        const frameStage = q('[data-frame-stage]');
        const frameThumb = q('.bfa-frame-thumb');
        const frameCaption = q('[data-frame-caption]');
        const variantId = q('[data-variant-id]');
        const fallback = q('[data-variant-fallback]');
        const status = q('[data-selection-status]');
        const priceEl = q('[data-variant-price]');
        const sizeStep = q('[data-size-step]');
        /* 🔴 3 numbered steps follow the options now, not 2. The frame colour
           step disappears on a frameless canvas and everything after it
           shifts, so all 3 are written here rather than in the markup. */
        const dogStep = q('[data-dog-step]');
        const photoStep = q('[data-photo-step]');
        const finishName = q('[data-finish-name]');
        const ctaPrice = q('[data-cta-price]');
        /* Looked up here, not 80 lines down, so paint() can never reach it
           before it exists. That was 1 added call away from throwing every
           product page into the native picker. */
        const sendLater = q('[data-send-later]');
        const uploadFields = q('[data-upload-fields]');
        const laterHelp = q('[data-later-help]');
        const sizeIdx = Number(el.dataset.sizeIndex || 0);
        const frameIdx = Number(el.dataset.frameIndex || 1);
        /* October 19, 2026: frame colors shown English first, "Black (Noir)".
           Display only; the option values matched below stay Noir, Cacao,
           Craie and Blond. The map comes from snippets/bfa-finish-label.liquid
           through the strings block, so the wording lives in 1 file. */
        const finishLabel = v => (strings.finishLabels && strings.finishLabels[v]) || v;
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:el.dataset.currency || 'USD',minimumFractionDigits:0,maximumFractionDigits:2});
        let current;
        let adding = false;
        let touched = false;

        /* The single source of truth. A combination exists only if a real
           variant carries both values at the right option positions. */
        const opt = (v, i) => (v.options && v.options[i] !== undefined) ? v.options[i] : (i === 0 ? v.option1 : i === 1 ? v.option2 : v.option3);
        const findVariant = (size, finish) => variants.find(v => opt(v, sizeIdx) === size && opt(v, frameIdx) === finish);

        const updateSubmit = () => {
          if (!submit) return;
          submit.disabled = adding || !current || !current.available;
          if (submitText) submitText.textContent = adding ? strings.adding : (current && current.available) ? strings.add : strings.soldOut;
          if (form) form.setAttribute('aria-busy', String(adding));
          qa('[data-enhanced-options] fieldset').forEach(fieldset => {fieldset.disabled = adding || fieldset.hidden;});
        };

        const showSlide = i => {
          qa('[data-gallery-slide]').forEach(slide => {slide.hidden = slide.dataset.gallerySlide !== String(i);});
          qa('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryIndex === String(i))));
        };
        qa('[data-gallery-index]').forEach(button => button.addEventListener('click', () => showSlide(button.dataset.galleryIndex)));

        /* Put the native picker back. It is the only control that is correct
           by construction, because Liquid writes only real variants into it. */
        const restoreNative = () => {
          if (!fallback) return;
          fallback.disabled = false;
          fallback.setAttribute('name','id');
          const wrap = q('[data-variant-fallback-wrap]');
          if (wrap) wrap.hidden = false;
          const enhanced = q('[data-enhanced-options]');
          if (enhanced) enhanced.hidden = true;
          if (variantId) variantId.disabled = true;
        };

        /* Neither canvas type is offered unless the product actually has
           variants of it. Without this, choosing a frame on a product with no
           framed variants disables every size and dead ends the shopper. */
        const hasKind = frameless => variants.some(v => (opt(v, frameIdx) === 'Frameless') === frameless);
        canvasTypes.forEach(input => {
          const ok = hasKind(input.value === 'frameless');
          input.disabled = !ok;
          const label = input.closest('label') || input.parentElement;
          if (label) label.classList.toggle('is-unavailable', !ok);
          if (!ok && input.checked) {
            const other = canvasTypes.find(i => i !== input && !i.disabled);
            if (other) other.checked = true;
          }
        });

        const syncInner = (fromFinish = false) => {
          const frameless = canvasTypes.find(input => input.checked)?.value === 'frameless';
          let color = finishes.find(input => input.checked);
          if (!color && finishes.length) { color = finishes[0]; color.checked = true; }
          const finish = frameless ? 'Frameless' : color?.value;
          if (colorOptions) colorOptions.hidden = frameless;
          if (sizeStep) sizeStep.textContent = frameless ? '02' : '03';
          if (dogStep) dogStep.textContent = frameless ? '03' : '04';
          if (photoStep) photoStep.textContent = frameless ? '04' : '05';

          /* Sizes, filtered by the chosen finish. A size that is not made in
             this finish is disabled and visibly struck rather than hidden, so
             the shopper learns the ladder instead of watching options vanish. */
          sizes.forEach(input => {
            const exists = !!findVariant(input.value, finish);
            input.disabled = !exists;
            const label = input.closest('label') || input.parentElement;
            if (label) label.classList.toggle('is-unavailable', !exists);
          });

          let selected = sizes.find(input => input.checked && !input.disabled);
          if (status) status.textContent = '';
          if (!selected) {
            selected = sizes.find(input => !input.disabled);
            if (selected) selected.checked = true;
            if (fromFinish && status) status.textContent = strings.reselect;
          }

          /* Finishes, filtered by the chosen size. This direction was missing
             and is why a wooden frame was offered on a frameless only size. */
          finishes.forEach(input => {
            const exists = !!findVariant(selected?.value, input.value);
            input.disabled = !exists;
            const label = input.closest('label') || input.parentElement;
            if (label) label.classList.toggle('is-unavailable', !exists);
          });

          current = findVariant(selected?.value, finish);

          if (!current) {
            /* Reachable only if a product has no variant at all for the
               chosen pairing. Say so, blank the price rather than leave the
               previous combination's number sitting above a form that cannot
               produce it, and refuse the sale. */
            if (status) status.textContent = strings.combo || '';
            if (priceEl) priceEl.textContent = '';
            if (ctaPrice) ctaPrice.textContent = '';
            if (variantId) variantId.value = '';
            if (fallback) fallback.value = '';
            updateSubmit();
            return;
          }

          if (variantId) variantId.value = current.id;
          if (fallback) fallback.value = String(current.id);
          if (priceEl) priceEl.textContent = money.format(current.price/100);
          if (ctaPrice) ctaPrice.textContent = '· ' + money.format(current.price/100);
          if (finishName) finishName.textContent = frameless ? strings.frameless : finishLabel(color?.value || '');
          updateSubmit();

          if (frameStage) {
            frameStage.dataset.finish = finish || 'Frameless';
            const img = frameStage.querySelector('img');
            if (img) img.alt = strings.frameAlt.replace('__TITLE__',el.dataset.productTitle || '').replace('__FINISH__',finishLabel(finish || ''));
            if (frameCaption) frameCaption.textContent = strings.frameCaption.replace('__FINISH__',finishLabel(finish || '')).replace('__SIZE__',selected?.value || '');
            if (frameThumb) frameThumb.dataset.finish = finish || 'Frameless';
            if (fromFinish) showSlide('frame');
          }

          /* Only after a real interaction. Rewriting it on load dirties every
             shared link and every analytics landing page value. */
          if (touched) {
            const next = new URL(window.location.href);
            next.searchParams.set('variant',current.id);
            history.replaceState(null,'',next);
          }
        };

        /* Every later call comes from a click, long after the native picker
           has been taken away, so a throw there used to leave a stale price
           and no way to buy. It now hands the form back. */
        const sync = (fromFinish = false) => {
          try {
            syncInner(fromFinish);
          } catch (error) {
            restoreNative();
            if (window.console) console.error('Atelier buy box handed back to the native picker:', error);
          }
        };

        finishes.forEach(input => input.addEventListener('change', () => { touched = true; sync(true); }));
        canvasTypes.forEach(input => input.addEventListener('change', () => { touched = true; sync(true); }));
        sizes.forEach(input => input.addEventListener('change', () => { touched = true; sync(); }));

        /* ---------------------------------------------------------------
           PHOTOGRAPHS. 1 drop zone, 5 real inputs behind it (8 on Le
           Sur-Mesure since October 14 2026, set by the photo_max section
           setting in sections/bfa-product.liquid).

           Shopify needs 1 named line item property per file, so the form
           still carries Photo 1 to Photo 5 (or 8). The shopper never sees
           them. They drag a handful in, or tap the zone on a phone and pick
           several straight from the camera roll, and the files are spread
           across the slots with no gaps between them.
        --------------------------------------------------------------- */
        const photoInputs = qa('[data-photo-input]');
        const drop = q('[data-drop]');
        const picker = q('[data-picker]');
        const photoCount = q('[data-photo-count]');
        /* Photo errors have their own element. They used to be written into
           the photo count, which paint() rewrites on the very next selection,
           so a rejected file was announced and then silently forgotten. */
        const photoError = q('[data-photo-error]');
        const photoList = q('[data-photo-list]');
        /* The cap is a section setting rather than a number typed in here, so
           the fine print under the zone and the check the script runs cannot
           quote 2 different figures. 18 if the attribute is missing or cannot
           be read, which is the default the setting carries.

           1000, not 1024. Shopify's own ceiling for a line item file is 20 MB
           counted in millions of bytes, so a MiB cap let a file through the
           zone that Shopify then refused at the cart. At 18 the setting sits
           2 MB under that line, and the editor can take it to 20 to sit on it. */
        const MAX_MB = Math.round(Number(el.dataset.maxFileMb)) > 0 ? Math.round(Number(el.dataset.maxFileMb)) : 18;
        const MAX_BYTES = MAX_MB*1000*1000;
        /* 1 key per rendered input, so the cart read back counts Photo 6 to 8
           on Le Sur-Mesure. A fixed list of 5 would count 5 of 8, call the
           upload lost and take a good line back out of the cart. */
        const PHOTO_KEYS = photoInputs.map((_, i) => 'Photo ' + (i + 1));
        const MIN_PHOTOS = 2;
        const OK_TYPES = ['image/jpeg','image/png','image/heic','image/heif'];
        const objectUrls = [];

        /* Type and size are asked separately now, because the shopper needs to
           be told which of the 2 was wrong. */
        const okType = f => !!f && (OK_TYPES.includes(f.type) || /\.(jpe?g|png|heic|heif)$/i.test(f.name));
        const okFile = f => okType(f) && f.size <= MAX_BYTES;

        const showPhotoError = message => { if (photoError) photoError.textContent = message; };
        const clearPhotoError = () => {
          if (photoError) photoError.textContent = '';
          if (drop) drop.classList.remove('is-error');
          if (result && result.dataset.error === 'true') result.hidden = true;
        };

        const chosenFiles = () => {
          const out = [];
          photoInputs.forEach(i => { if (i.files && i.files.length) out.push(i.files[0]); });
          return out;
        };

        const paint = () => {
          const files = chosenFiles();
          if (photoCount) {
            photoCount.textContent = files.length
              ? (files.length === 1 ? strings.readyOne : String(strings.readyMany || '').replace(/__N__/g, files.length))
              : '';
          }
          if (photoList) photoList.textContent = '';
          objectUrls.splice(0).forEach(u => { try { URL.revokeObjectURL(u); } catch (e) {} });
          if (photoList) {
            files.forEach((f, idx) => {
              const li = document.createElement('li');
              const img = document.createElement('img');
              const src = URL.createObjectURL(f);
              objectUrls.push(src);
              img.src = src; img.width = 46; img.height = 46; img.alt = '';
              const name = document.createElement('span');
              name.textContent = f.name;
              const kill = document.createElement('button');
              kill.type = 'button';
              kill.className = 'bfa-photo-remove';
              kill.setAttribute('aria-label', (strings.removePhoto || 'Remove') + ': ' + f.name);
              kill.textContent = '×';
              kill.addEventListener('click', () => {
                /* Here rather than in paint(), which also runs on every add and
                   would wipe the message for the file just refused. */
                clearPhotoError();
                const keep = chosenFiles().filter((_, i) => i !== idx);
                write(keep);
              });
              li.append(img, name, kill);
              photoList.append(li);
            });
          }
          /* 🔴 NO FIELD IS MARKED REQUIRED. The dog's name and weight stay
             optional. The photographs are enforced in the submit handler
             instead (2 minimum, or reused, or send later ticked, since
             October 9, 2026), not with the required attribute, because a
             required file input cannot tell a reused or later photo apart. */
          photoInputs.forEach(i => { i.required = false; });
        };

        /* DataTransfer is how a chosen file is moved into a named input, and
           it does not exist on Safari before 14.1. write() is called from
           change and drop listeners, which are outside the setup try, so an
           uncaught throw there would leave the shopper with no thumbnails,
           empty inputs and no error. It hands the browser its own file
           pickers back instead. */
        const write = files => {
          try {
            const all = files.slice(0, photoInputs.length);
            photoInputs.forEach((input, i) => {
              const dt = new DataTransfer();
              if (all[i]) dt.items.add(all[i]);
              input.files = dt.files;
            });
            paint();
          } catch (error) {
            if (drop) drop.hidden = true;
            photoInputs.forEach(i => { i.classList.add('bfa-upload-fallback'); i.removeAttribute('tabindex'); });
            const wrap = photoInputs[0] && photoInputs[0].parentElement;
            if (wrap) wrap.classList.remove('bfa-visually-hidden');
            if (window.console) console.warn('Atelier drop zone unavailable, native file inputs restored:', error);
          }
        };

        /* Every reason a file was refused is named and counted: too large,
           not a photograph we can read, and more than the slots can hold.
           The extras used to be sliced off the end in write() with nothing
           said about them. */
        const note = (one, many, n) => n === 1 ? String(one || '') : String(many || '').replace(/__N__/g, n);
        const accept = incoming => {
          clearPhotoError();
          const good = [], big = [], wrong = [];
          Array.prototype.forEach.call(incoming, f => {
            if (!okType(f)) { wrong.push(f); return; }
            if (f.size > MAX_BYTES) { big.push(f); return; }
            good.push(f);
          });
          const room = Math.max(0, photoInputs.length - chosenFiles().length);
          const dropped = Math.max(0, good.length - room);
          const kept = dropped ? good.slice(0, room) : good;
          const notes = [];
          if (big.length) notes.push(note(strings.fileTooBigOne, strings.fileTooBigMany, big.length));
          if (wrong.length) notes.push(note(strings.fileWrongTypeOne, strings.fileWrongTypeMany, wrong.length));
          if (dropped) notes.push(note(strings.fileTooManyOne, strings.fileTooManyMany, dropped).replace(/__MAX__/g, photoInputs.length));
          if (notes.length) showPhotoError(notes.join(' '));
          if (!kept.length) return;
          write(chosenFiles().concat(kept));
          if (chosenFiles().length) bfaClarity('event', 'atelier_photo_uploaded');
        };

        if (picker) picker.addEventListener('change', () => { accept(picker.files); picker.value = ''; });
        if (drop) {
          ['dragenter','dragover'].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.add('is-over'); }));
          ['dragleave','drop'].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.remove('is-over'); }));
          drop.addEventListener('drop', e => { if (e.dataTransfer && e.dataTransfer.files) accept(e.dataTransfer.files); });
        }

        const validatePhoto = input => {
          const file = input.files[0];
          const invalid = !input.disabled && file && !okFile(file);
          input.setCustomValidity(invalid ? strings.fileError : '');
          return !invalid;
        };

        const syncPhotos = () => {
          const later = !!sendLater && sendLater.checked;
          photoInputs.forEach(input => {input.disabled = later; input.required = false; validatePhoto(input);});
          if (uploadFields) uploadFields.hidden = later;
          if (laterHelp) laterHelp.hidden = !later;
          paint();
        };
        if (sendLater) sendLater.addEventListener('change', () => { clearPhotoError(); syncPhotos(); });

        /* ---------------------------------------------------------------
           A 200 from the cart proves the LINE was created. It proves nothing
           at all about the photographs: a file can be lost between the
           browser and the cart and the response says the same either way.
           So the cart is read back and the line is counted, and a line that
           came up short is taken straight back out.
        --------------------------------------------------------------- */
        /* Only a message we wrote is ever shown. "Failed to fetch" and
           "Unexpected token <" are browser strings, not copy, and in the verify
           path they would sit above a line we had just taken back out. */
        const friendly = message => { const error = new Error(message); error.bfa = true; return error; };

        const countLanded = line => {
          const props = (line && line.properties) || {};
          let landed = 0;
          PHOTO_KEYS.forEach(key => {
            const value = props[key];
            if (typeof value === 'string' && value.length > 0) landed++;
          });
          return landed;
        };

        const verify = async (item, expected) => {
          /* A cached cart would roll back a line that is perfectly fine. */
          const response = await fetch(el.dataset.cartUrl || '/cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
          if (!response.ok) throw friendly(strings.uploadLost);
          const cart = await response.json();
          const line = (cart.items || []).find(item2 => item2.key === (item && item.key));
          if (countLanded(line) < expected) throw friendly(strings.uploadLost);
        };

        const removeLine = async item => {
          if (!item || !item.key) return true;
          try {
            const response = await fetch(el.dataset.changeUrl || '/cart/change.js', {
              method:'POST',
              credentials:'same-origin',
              headers:{'Content-Type':'application/json',Accept:'application/json'},
              /* Shopify merges lines that carry identical properties, so the
                 line can hold more than the 1 unit just added. Taking the line
                 to 0 would delete a piece the customer still wants. */
              body: JSON.stringify({id:item.key,quantity:Math.max(0, (Number(item.quantity) || 1) - 1)})
            });
            return response.ok;
          } catch (error) {
            return false;
          }
        };

        /* 1 place writes the result panel, so a node that is not there cannot
           turn a handled failure into an unhandled rejection. */
        const showResult = (message, isError) => {
          if (!result) return;
          result.dataset.error = String(isError);
          const text = result.querySelector('p');
          if (text) text.textContent = message;
          const link = result.querySelector('a');
          if (link) link.hidden = isError;
          result.hidden = false;
          result.scrollIntoView({block:'nearest',behavior:'smooth'});
        };

        if (form) form.addEventListener('submit', async event => {
          if (fallback && !fallback.disabled) return;
          event.preventDefault();
          if (adding || !current || !current.available) return;
          syncPhotos();
          if (!form.reportValidity()) return;
          /* October 9, 2026 (Nico). A canvas needs at least 2 photographs at
             add to cart, or photographs reused from a canvas already in the
             cart (snippets/bfa-prefill.liquid carries those as hidden
             _Reused photo inputs), or the send photos later box ticked.
             Before this an order could go through with 0 photographs and
             nothing on it to say they were coming, so nobody chased it. */
          {
            const laterTicked = !!sendLater && sendLater.checked;
            const reused = form.querySelectorAll('[data-bfa-prefill-carry] input[name^="properties[_Reused photo"]').length;
            if (!laterTicked && reused === 0 && chosenFiles().length < MIN_PHOTOS) {
              const photoMsg = strings.photosNeeded || 'Please add at least 2 photos of your dog, or tick the box to send them later.';
              showPhotoError(photoMsg);
              if (drop) drop.classList.add('is-error');
              /* Also written into the result panel above the button, without
                 the panel's own scroll, so 2 smooth scrolls never fight. */
              if (result) {
                result.dataset.error = 'true';
                const rp = result.querySelector('p'); if (rp) rp.textContent = photoMsg;
                const rl = result.querySelector('a'); if (rl) rl.hidden = true;
                result.hidden = false;
              }
              /* October 10, 2026. On phones the shopper taps the sticky bar at
                 the bottom while the photo step is far above, so the page is
                 moved explicitly to the drop zone, 140px under the top to clear
                 the fixed header. scrollIntoView alone was unreliable there. */
              const target = drop || q('[data-photo-error]');
              if (target) {
                const y = target.getBoundingClientRect().top + window.pageYOffset - 140;
                window.scrollTo(0, Math.max(0, y));
              }
              return;
            }
          }
          adding = true; updateSubmit(); if (result) result.hidden = true;
          /* Counted before the post, because this is the number the cart has
             to give back. Nothing is expected when the photos follow later. */
          const sendingLater = !!sendLater && sendLater.checked;
          const expected = sendingLater ? 0 : chosenFiles().length;
          let added = null;
          try {
            const body = new FormData(form);
            body.delete('bfa-size'); body.delete('bfa-finish'); body.delete('bfa-canvas-type'); body.delete('bfa-dog-count');
            photoInputs.forEach(input => {if (!input.files.length || input.disabled) body.delete(input.name);});
            const response = await fetch(el.dataset.addUrl, {method:'POST',body,headers:{Accept:'application/json'}});
            /* A 429 or an HTML error page is not JSON, and parsing it threw a
               SyntaxError whose text went straight to the customer. */
            let data = null;
            try { data = await response.json(); } catch (parseError) { data = null; }
            if (!response.ok) throw friendly(data && typeof data.description === 'string' ? data.description : strings.error);
            if (!data) throw friendly(strings.error);
            added = data;
            if (expected > 0) await verify(data, expected);
            added = null;
            showResult(strings.added, false);
            bfaCartHasCanvas = true;
            bfaClarity('event', 'atelier_add_to_cart');
            document.querySelectorAll('[data-cart-count]').forEach(count => {count.textContent = String(Number(count.textContent || 0)+1);});
          } catch (error) {
            let message = (error && error.bfa && error.message) ? error.message : strings.error;
            try {
              if (added) {
                const removed = await removeLine(added);
                added = null;
                if (!removed) message = strings.uploadStuck || message;
              }
            } catch (cleanup) {
              message = strings.uploadStuck || message;
            }
            showResult(message, true);
          } finally {adding = false; updateSubmit();}
        });

        sync();
        syncPhotos();
        /* Chosen from the DOM rather than from a feature flag that lives in
           another file. With a featured image every media figure is rendered
           hidden and the first is skipped, so if the frame slide were missing
           showSlide(0) would match nothing and open on a blank gallery. */
        const firstSlide = q('[data-gallery-slide]');
        showSlide(q('[data-gallery-slide="frame"]') ? 'frame' : (firstSlide ? firstSlide.dataset.gallerySlide : 0));
        ready = true;

        /* Only now, with everything wired and a real variant selected, do we
           take the native select away. Gated on a real variant, not merely on
           nothing having thrown. A clean run that selected nothing must NOT
           take the native picker away, which is exactly how the old build
           left a dead Add to cart. */
        if (fallback && current) {
          fallback.disabled = true;
          fallback.removeAttribute('name');
          const wrap = q('[data-variant-fallback-wrap]');
          if (wrap) wrap.hidden = true;
          const enhanced = q('[data-enhanced-options]');
          if (enhanced) enhanced.hidden = false;
          const laterChoice = q('[data-later-choice]');
          if (laterChoice) laterChoice.hidden = false;
          if (variantId) variantId.disabled = false;
        }
      } catch (error) {
        /* The native select is still in the page, still named id, and still
           lists only real variants. The shopper can buy. */
        if (!ready && window.console) console.error('Atelier buy box fell back to the native picker:', error);
      }
    });
  };
  const ready = () => {
    init();
    /* The cart is read once on load and again whenever the drawer redraws,
       so the checkout click below can tell, without waiting, whether the
       cart holds a canvas. The click itself is never delayed or stopped. */
    bfaCheckCart();
    const drawerBody = document.querySelector('[data-drawer-body]');
    if (drawerBody && window.MutationObserver) {
      let timer = null;
      new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(bfaCheckCart, 300); }).observe(drawerBody, {childList:true, subtree:true});
    }
    document.addEventListener('click', event => {
      const target = event.target && event.target.closest ? event.target.closest('.bfa-drawer-checkout, [name="checkout"], a[href="/cart/checkout"], a[href="/checkout"]') : null;
      if (target && bfaCartHasCanvas) bfaClarity('event', 'atelier_begin_checkout');
    }, true);
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.getElementById('bfa-mobile-menu');
    if (toggle && menu) {
      const close = () => {menu.hidden = true; toggle.setAttribute('aria-expanded','false');};
      toggle.addEventListener('click', () => {menu.hidden = !menu.hidden; toggle.setAttribute('aria-expanded',String(!menu.hidden));});
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
      document.addEventListener('keydown',event => {if(event.key === 'Escape' && !menu.hidden) {close(); toggle.focus();}});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready); else ready();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
